import React, { Fragment } from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input, } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useMicThermometer } from '../../../hooks/micThermometer/useMicThermometer';
import { DialogMicThermometer } from '../../../components/micThermometer/DialogMicThermometer';

export const IndexMicThermometer = () => {
    const {
        visible, setVisible, handleInputChange, handleCreate, saveCreateThermometer, handleUpdate, saveUpdateThermometers,
        loading, setLoading, method, handleDelete, listThermometers, formValues, handleSearchThermometer

    } = useMicThermometer();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => (
    <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
        <Button 
        color="primary" 
        size="sm"
        onClick={() => handleUpdate(rowData)}
        disabled={loading}
        style={{
            padding: "2px",
            fontSize: "1rem",
            height: "26px",
            width: "26px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
        >
        <i className="fa fa-edit"></i>
        </Button>

        <Button 
        color="danger" 
        size="sm"
        onClick={() => handleDelete(rowData)}
        disabled={loading}
        style={{
            padding: "2px",
            fontSize: "1rem",
            height: "26px",
            width: "26px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
        >
        <i className="fa fa-trash"></i>
        </Button>
    </div>
    );

    const header = (
        // <div className="d-flex align-items-center" style={{ justifyContent: 'space-between', width: '100%', gap: '1rem' }} >
        //     {/* <button className="p-button p-button-success"  title="Listado de pacientes" style={{ alignItems: "center", padding: "5px 8px", height: "35px", width: "35px", fontSize: "0.9rem", display: "flex", justifyContent: "center", position: "relative"}} >
        //         <i className="pi pi-file-excel" style={{ fontSize: "1rem" }}></i>
        //     </button> */}
        //     <Input placeholder='Busqueda...' className='form-control'  onChange={handleSearchThermometer} style={{ maxWidth: '450px', width: '100%' }} />
            
        // </div>
        <div className="d-flex align-items-center" style={{ justifyContent: 'flex-end', width: '100%' }}>
    <Input
        placeholder="Busqueda..."
        className="form-control"
        onChange={handleSearchThermometer}
        style={{ maxWidth: '450px', width: '100%' }}
    />
</div>

    );
    
    return (
        <>
            <Fragment>
                <Container fluid={true} className="p-4 p-l-0 p-r-0" style={{  scrollBehavior: "smooth" , transform: "scale(0.8)",    width: "125%",    transformOrigin: "top left" }} >
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody className="p-1">
                                    <div className="ribbon ribbon-clip ribbon-primary">
                                        Catálogo de Termómetros
                                    </div>

                                    <div className="text-right" style={{ margin: 5, padding: 0 }}>
                                        <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={() => handleCreate()} >
                                            <span className="fa fa-plus-circle"></span>
                                        </Button>
                                    </div>

                                    <br /><br />

                                    <Col sm="12">
                                        <div className="table-responsive">
                                            <DataTable 
                                                value={listThermometers} 
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 20, 50]} 
                                                header={header}
                                                className="data-table p-datatable-striped p-datatable-sm"
                                                responsiveLayout="scroll"
                                                emptyMessage={
                                                    <div className="text-center">
                                                        <img 
                                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} 
                                                            style={{ width: "35%" }} 
                                                            alt="Sin resultados" 
                                                        />
                                                        <br />
                                                        <p className='badge badge-light-primary mt-2' style={{fontSize: "15px"}}>
                                                            No hay coincidencias con la búsqueda.
                                                        </p>
                                                    </div>
                                                }
                                                >
                
                                                <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                                <Column field="name_thermometer" header="Nombre del termómetro"  headerStyle={headerStyle} style={centerStyle} />
                                                <Column field="abbreviation" header="abreviación" headerStyle={headerStyle} style={centerStyle}/>
                                                <Column field="internal_thermometer" header="Termómetro interno"  headerStyle={headerStyle} style={centerStyle} />
                                                <Column field="correction_factor" header="Factor de corrección" headerStyle={headerStyle} style={centerStyle}/>
                    
                                                <Column header="Acciones" body={actions}exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                            </DataTable>
                                        </div>
                                    </Col>
                                </CardBody>
                            </Card>
                            {<DialogMicThermometer
                                {...{
                                    visible, setVisible, handleInputChange, handleCreate, saveCreateThermometer, handleUpdate, saveUpdateThermometers,
                                    loading, setLoading, method, handleDelete, listThermometers, formValues
                                }}
                            />}
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        </>
    )
}
